import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon, Package } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ParentEmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'default' | 'outline' | 'secondary';
  };
  className?: string;
}

export const ParentEmptyState: React.FC<ParentEmptyStateProps> = ({
  title,
  description,
  icon: Icon = Package,
  action,
  className
}) => {
  return (
    <div className={cn('flex flex-col items-center justify-center py-8 sm:py-12 px-4 text-center', className)}>
      <div className="flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-gradient-to-br from-gray-100 to-gray-50 border border-gray-200 mb-3 sm:mb-4">
        <Icon className="h-6 w-6 sm:h-8 sm:w-8 text-gray-400" />
      </div>
      
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
        {title}
      </h3>
      
      {description && (
        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 max-w-sm sm:max-w-md">
          {description}
        </p>
      )}
      
      {action && (
        <Button
          onClick={action.onClick}
          variant={action.variant || 'default'}
          size="sm"
          className="w-full xs:w-auto"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

export default ParentEmptyState;